import { jsx as s } from "react/jsx-runtime";
import { cn as i } from "./designsystem-ui-react47.js";
function o({
  lines: e = 4,
  hideOnMobile: l = !1,
  className: m,
  children: a
}) {
  const c = {
    0: "",
    1: "line-clamp-1",
    2: "line-clamp-2",
    3: "line-clamp-3",
    4: "line-clamp-4",
    5: "line-clamp-5",
    6: "line-clamp-6"
  }, n = e >= 0 && e <= 6 ? e : 4;
  return /* @__PURE__ */ s(
    "div",
    {
      className: i(
        "text-sm @sm:text-base",
        c[n],
        l && "hidden @sm:block",
        m
      ),
      children: a
    }
  );
}
export {
  o as CardDescription
};
